/**
 * @generated SignedSource<<72aff298cbb014b174012a7a698a8e32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderEditInvoice_order$data = {
  readonly id: string;
  readonly invoice: {
    readonly " $fragmentSpreads": FragmentRefs<"StoredFile_file">;
  } | null;
  readonly " $fragmentType": "OrderEditInvoice_order";
};
export type OrderEditInvoice_order$key = {
  readonly " $data"?: OrderEditInvoice_order$data;
  readonly " $fragmentSpreads": FragmentRefs<"OrderEditInvoice_order">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrderEditInvoice_order",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoredFile",
      "kind": "LinkedField",
      "name": "invoice",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "StoredFile_file"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Order",
  "abstractKey": null
};

(node as any).hash = "700796721d8859bddc9e495b4a111c39";

export default node;
